
import { Controller } from "@hotwired/stimulus";
import ApexCharts from "apexcharts";

// Connects to data-controller="queries--bar-chart"
export default class extends Controller {
  static values = {
    data: Array,
    categories: Array,
  };

  connect() {
    this.setTeamChartColors();
  }

  setTeamChartColors() {
    const teamColorScheme = ["#4f46e5", "#cbd5e1"];
    const teamChartOptions = {
      series: this.dataValue,
      dataLabels: {
        enabled: false,
      },
      colors: teamColorScheme,
      chart: {
        type: 'bar',
        height: 380,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          borderRadius: 5,
          borderRadiusApplication: 'end'
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      fill: {
        opacity: 1
      },
      xaxis: {
        lines: {
          show: false,
        },
        labels: {
          style: {
            colors: this.isDarkMode ? "#ffffff" : "#333",
          },
        },
        categories: this.categoriesValue,

        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },

        labels: {
          show: false,
        },
      },
      tooltip: {
        theme: "dark",
        x: {
          show: false,
        },
        y: {
          formatter: this.valueFormatter,
        },
      },
      legend: {
        show: false,
      },

      grid: {
        show: false,
      },
    };

    if (this.teamChart) {
      this.teamChart.destroy();
    }

    this.teamChart = new ApexCharts(this.element, teamChartOptions);

    this.teamChart.render();
  }
}
